import { render, staticRenderFns } from "./profileDisplay.vue?vue&type=template&id=6f47eb2d&scoped=true"
import script from "./profileDisplay.vue?vue&type=script&lang=js"
export * from "./profileDisplay.vue?vue&type=script&lang=js"
import style0 from "./profileDisplay.vue?vue&type=style&index=0&id=6f47eb2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f47eb2d",
  null
  
)

export default component.exports